/* @flow */
// typecheck: ignore file
import React from 'react';

import AuthActions from 'auth/AuthActions';
import { FormattedMessage } from 'react-intl';
import Glyph from 'components/Glyph.jsx';
import LayerTrigger from 'components/LayerTrigger.jsx';
import Link from 'components/Link.jsx';
import LinkConstants from 'constants/LinkConstants';
import ModalTrigger from 'components/ModalTrigger.jsx';
import NavigationMenu from 'components/NavigationMenu.jsx';
import TextAppLinkDialog from 'user/components/TextAppLinkDialog.jsx';

type Props = {
  showRCE?: boolean,
  showLogout?: boolean,
  showSettings?: boolean,
  showGetTheApp?: boolean,
  children?: React$Element<*>,
};

class UserNavigationMenu extends React.Component {
  props: Props;

  signOut = () => {
    AuthActions.signOut();
  };

  renderMenu() {
    const { showRCE, showSettings, showGetTheApp, showLogout } = this.props;

    return (
      <NavigationMenu>
        {showSettings &&
          <Link to="/settings" eventElementName="Navigation-account" color="thunder">
            <Glyph name="avatar" size="large" />
            <FormattedMessage
              id="navigation.settings"
              defaultMessage="Account"
            />
          </Link>
        }
        {showGetTheApp &&
          <ModalTrigger modal={<TextAppLinkDialog />}>
            <Link eventElementName="Navigation-getTheApp" color="thunder">
              <Glyph name="mobile" size="large" />
              <FormattedMessage
                id="navigation.getTheApp"
                defaultMessage="Get the Remind app"
              />
            </Link>
          </ModalTrigger>
        }
        {showRCE &&
          <Link
            href={LinkConstants.RCE}
            target="_blank"
            eventElementName="Navigation-rce"
            color="thunder">
            <Glyph name="apple" size="large" />
            <FormattedMessage
              id="navigation.rce"
              defaultMessage="Connected Educator"
            />
          </Link>
        }
        {showLogout &&
          <Link onClick={this.signOut} eventElementName="Navigation-logOut" color="thunder">
            <Glyph name="sign-out" size="large" />
            <FormattedMessage
              id="navigation.logout"
              defaultMessage="Log out"
            />
          </Link>
        }
      </NavigationMenu>
    );
  }

  render() {
    return (
      <LayerTrigger layer={this.renderMenu()} trigger="click" placement="bottom">
        {this.props.children}
      </LayerTrigger>
    );
  }
}


export default UserNavigationMenu;



// WEBPACK FOOTER //
// ./src/components/UserNavigationMenu.jsx